import axiosInstance from '../axiosInstance';

// Obtener todos los tipos de comprobante
export const fetchComprobanteTypes = async () => {
  const response = await axiosInstance.get('/accounting/invoiceType');
  return response.data;
};

// Crear un nuevo tipo de comprobante
export const createComprobanteType = async (data) => {
  const response = await axiosInstance.post('/accounting/invoiceType', data);
  return response.data;
};

// Actualizar un tipo de comprobante
export const updateComprobanteType = async (id, data) => {
  const response = await axiosInstance.put(`/accounting/invoiceType/${id}`, data);
  return response.data;
};

// Eliminar un tipo de comprobante
export const deleteComprobanteType = async (id) => {
  const response = await axiosInstance.delete(`/accounting/invoiceType/${id}`);
  return response.data;
};
